module.exports = __webpack_public_path__ + "static/media/OneNetLogo.ade331c8.svg";